import LangEnum from '../../../../../../../../lang/LangEnum';
import { OrderError } from '../../../../../../edit/sections/OrderEditSections.types';

export type OrderGeneralDataFieldWithError =
  | 'customer'
  | 'salesRepresentative'
  | 'priceTable'
  | 'consultant';

const FIELDS_BY_ERROR_CODE: Partial<Record<LangEnum, OrderGeneralDataFieldWithError[]>> = {
  [LangEnum.ORDER_RULE_CUSTOMER_REQUIRED_RULE]: ['customer'],
  [LangEnum.API_EXCEPTION_ORDER_UNPROCESSABLE_CUSTOMER_NOT_APPROVED]: ['customer'],
  [LangEnum.API_EXCEPTION_ORDER_UNPROCESSABLE_CUSTOMER_NOT_APPROVED_BY_STATUS_RULE]: ['customer'],
  [LangEnum.ORDER_RULE_SALES_REPRESENTATIVE_REQUIRED_RULE]: ['salesRepresentative'],
  [LangEnum.ORDER_RULE_SALES_REPRESENTATIVE_INACTIVE_RULE]: ['salesRepresentative'],
  [LangEnum.ORDER_RULE_PRICE_TABLE_NOT_MATCH_CUSTOMER__RESTRICTION_RULE]: [
    'priceTable',
    'customer',
  ],
  [LangEnum.ORDER_RULE_PRICE_TABLE_NOT_MATCH_SALES_REPRESENTATIVE_RULE]: [
    'priceTable',
    'salesRepresentative',
  ],
  [LangEnum.PRICE_TABLE_INACTIVE_TO_CHANGE_STATUS]: ['priceTable'],
  [LangEnum.ORDER_RULE_CONSULTANT_INACTIVE_RULE]: ['consultant'],
};

export const getOrderGeneralDataFieldsWithError = (
  errors: OrderError[] = [],
): Set<OrderGeneralDataFieldWithError> =>
  new Set(errors.flatMap(({ messageCode }) => FIELDS_BY_ERROR_CODE[messageCode] ?? []));
